import { connect } from 'react-redux';
import * as actions from 'embed/actions';
import reducers from 'embed/reducers';
import CartPageNotice from 'embed/components/CartPageNotice'

export default connect(reducers, actions)(CartPageNotice);
